<template>
  <div class="$mq">

    <!-- kategoriat -->
    <!-- <div v-if="this.$route.params.topic_id === 'mika-tama-sovellus-on?'" class="mb-6">
      <div class="flex">
        <div
          v-for="(categ, index) in sortedCategories"
          :key="index"
          @click="currentCategory = categ.title"
          :class="{ active: currentCategory === categ.title }"
          class="flex flex-column flex-1 align-center mx-1"
        >
          <div :class="['group-' + categ.class, { active: currentCategory === categ.title }]" class="categ-ball rounded-full flex flex-center noselect">
            <i class="material-icons color-white">{{categ.icon}}</i>
          </div>
        </div>
      </div>
      <p class="txt-bold">kategoria: {{this.currentCategory}}</p>
    </div> -->

    <!-- otsikot -->
    <div class="flex">
      <div class="flex-1 txt-bold" style="letter-spacing: 0.04rem;">TILA</div>
      <div class="flex-1 txt-bold" style="text-align: right; letter-spacing: 0.02rem;">TAUSTATEKIJÄT</div>
    </div>

    <!-- keinokaavio -->
    <div class="toolboxGrid mt-3" :class="{ [$mq]: $mq, specialcase: !currentItem }"> <!-- .specialcase ainoastaan "mikä tämä seovellus on?"-sivua varten -->

      <!-- means - spaces -->
      <div :style="{ gridTemplateRows: 'repeat(' + toolboxData.spacesAmount + ', auto' }" class="mean-of-spaces">
        <router-link
          v-for="(keino, index) in toolboxData.spaces"
          :key="index"
          :to="{ name: 'keino', params: { mean_id: keino.slug } }"
          tag="div"
          :class="{ active: keino.active }"
          class="mb-1"
        >
          <!-- pyöreä kategoriaväri -->
          <div class="h-full flex flex-center">
            <div :class="setClass(keino.ref)" class="toolbox-mean-color rounded-full" style="width: 15px; height: 15px;"></div>
          </div>
          <!-- <div :class="setClass(keino.ref)"></div> -->
          <div class="flex align-center break-word px-2 lheight-8">{{keino.title}}</div>
        </router-link>
      </div>

      <!-- means - settings -->
      <div :style="{ gridTemplateRows: 'repeat(' + toolboxData.settingsAmount + ', auto' }" class="mean-of-settings">
        <router-link
          v-for="(keino, index) in toolboxData.settings"
          :key="index"
          :to="{ name: 'keino', params: { mean_id: keino.slug } }"
          tag="div"
          :class="{ active: keino.active }"
          style="text-align: right;"
        >
          <!-- pyöreä kategoriaväri -->
          <div class="flex align-center justify-end break-word px-2 lheight-8">{{keino.title}}</div>
          <!-- <div :class="setClass(keino.ref)"></div> -->
          <div class="h-full flex flex-center">
            <div :class="setClass(keino.ref)" class="toolbox-mean-color rounded-full" style="width: 15px; height: 15px;"></div>
          </div>
        </router-link>
      </div>

    </div>

    <!-- kategoriat -->
    <div v-if="this.$route.params.topic_id === 'mika-tama-sovellus-on?'">
      <hr class="my-8" style="border: 0; border-top: 1px solid lightgrey;"> <!-- divider -->
      <!-- <router-link
        to="/keinot"
        tag="div"
        class="txt-bold mb-3 flex align-center pointer"
        style="letter-spacing: 0.04rem;"
      >
        KEINOKATEGORIAT <i class="material-icons color-grey ml-1" style="transform: rotate(45deg);">link</i>
      </router-link> -->
      <div class="flex justify-between">
        <div class="flex-1 flex flex-column">
          <div v-for="(categ, index) in sortedCategoriesNew.spaces" :key="index" class="flex align-center justify-start mb-2" style="cursor: default;">
            <!-- <div :class="`group-${categ.class}`" class="rounded-full wh-1-5 flex flex-center flex-shrink-0 mr-2">
              <i class="material-icons font-10 color-white" style="cursor: default;">{{ categ.icon }}</i>
            </div> -->
            <div :class="`group-${categ.class}-text`" class="flex justify-start txt-bold">
              {{ categ.title }}
              <!-- <span :class="`group-${categ.class}-text`" class="txt-bold">{{ categ.title }}</span> -->
            </div>
          </div>
        </div>
        <div class="flex-1 flex flex-column">
          <div v-for="(categ, index) in sortedCategoriesNew.settings" :key="index" class="flex align-center justify-end mb-2" style="cursor: default;">
            <div :class="`group-${categ.class}-text`" class="flex justify-end txt-bold" style="text-align: right;">
              {{ categ.title }}
              <!-- <span :class="`group-${categ.class}-text`" class="txt-bold">{{ categ.title }}</span> -->
            </div>
            <!-- <div :class="`group-${categ.class}`" class="rounded-full wh-1-5 flex flex-center flex-shrink-0 ml-2">
              <i class="material-icons font-10 color-white" style="cursor: default;">{{ categ.icon }}</i>
            </div> -->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  /* props: ['currentItem'], */
  props: {
    currentItem: {
      type: Object
    }
  },

  data () {
    return {
      // categories: this.$store.state.vuexCategories,
      currentCategory: 'Rungon tilallinen potentiaali'
    }
  },

  created () {
    this.$store.dispatch('storeCategories')
    this.$store.dispatch('storeMeans')
  },

  computed: {
    toolboxData () {
      let allMeans = []
      this.$store.state.means.forEach(mean => {
        allMeans.push({
          title: mean.title,
          ref: mean.ref,
          slug: mean.slug,
          active: false
        })
      })

      let spaces = []
      let settings = []

      allMeans.forEach(mean => {
        let addedMeans = []
        if (this.currentItem) {
          this.currentItem.addedMeans.forEach(e => {
            addedMeans.push(e.title)
          })
          if (addedMeans.some(e => { return e === mean.title })) {
            mean.active = true
          }
        }
        if (mean.ref === 'A' || mean.ref === 'B' || mean.ref === 'C') {
          spaces.push(mean)
        } else {
          settings.push(mean)
        }
      })

      let arrangedSpaces = spaces.slice()
      arrangedSpaces.sort(this.compareValues('ref'))
      let arrangedSettings = settings.slice()
      arrangedSettings.sort(this.compareValues('ref'))

      return {
        spaces: arrangedSpaces,
        settings: arrangedSettings,
        spacesAmount: spaces.length,
        settingsAmount: settings.length
      }
    },

    sortedCategories () {
      let temp = this.$store.state.categories.slice()
      temp.sort(this.compareValues('class'))
      return temp
    },

    sortedCategoriesNew () {
      let temppi = this.$store.state.categories.slice()
      let spaces = []
      let settings = []
      temppi.forEach(t => {
        if (t.class === 'A' || t.class === 'B' || t.class === 'C') {
          spaces.push(t)
        } else {
          settings.push(t)
        }
      })
      spaces.sort(this.compareValues('class'))
      settings.sort(this.compareValues('class'))
      return {
        spaces: spaces,
        settings: settings
      }
    }
  },

  methods: {
    /* showCategoryName (title) {
      this.currentCategory = title
    }, */

    setClass (ref) {
      return {
        ['group-' + ref]: true
      }
    },

    // dynamic sorting function:
    compareValues (key, order = 'asc') {
      return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) { // property doesn't exist on either object
          return 0
        }

        const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key]
        const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key]

        let comparison = 0
        if (varA > varB) {
          comparison = 1
        } else if (varA < varB) {
          comparison = -1
        }
        return (
          (order === 'desc') ? (comparison * -1) : comparison
        )
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

.toolboxGrid {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(2, 1fr);
  font-size: 14px;
  color: rgb(80, 80, 80);
  &.phone { font-size: 12px; }
  .mean-of-spaces {
    display: grid;
    grid-gap: 6px;
    & > div {
      //width: 10px;
      display: grid;
      grid-template-columns: 15px 1fr;
      border-radius: 7.5px;
      cursor: pointer;
      &:hover { background-color: rgb(235, 235, 235); }
    }
  }
  .mean-of-settings {
    display: grid;
    grid-gap: 3px;
    /* & *:not(.active) { pointer-events: none;} */
    & > div {
      //width: 10px;
      display: grid;
      grid-template-columns: 1fr 15px;
      border-radius: 7.5px;
      cursor: pointer;
      &:hover { background-color: rgb(235, 235, 235); }
    }
  }
  /* .mean-of-spaces > div:not(.active) .toolbox-mean-color,
  .mean-of-settings > div:not(.active) .toolbox-mean-color {
    background-color: rgba(0, 0, 0, 0.2) !important;
  } */
}
.toolboxGrid:not(.specialcase) { // this is only for example.vue
  .mean-of-spaces > div,
  .mean-of-settings > div {
    opacity: 0.4;
  }
  .mean-of-spaces > div:not(.active) .toolbox-mean-color,
  .mean-of-settings > div:not(.active) .toolbox-mean-color {
    background-color: rgba(0, 0, 0, 0.2) !important;
  }
  .active {
    opacity: 1 !important;
    color: black;
    font-weight: bold;
    background-color: rgb(235, 235, 235);
  }
}

.categ-ball {
  width: 2.6rem;
  height: 2.6rem;
  opacity: 0.4;
  .phone & {
    width: 1.8rem;
    height: 1.8rem;
    i { font-size: 1.2rem; }
  }
  &.active { opacity: 1; }
}
</style>
